export const types = {
  FUND_QUOTA: 'currentPositionPage/FUND_QUOTA',
  FUND_QUOTA_SUCCESS: 'currentPositionPage/FUND_QUOTA_SUCCESS',
  FUND_QUOTA_ERROR: 'currentPositionPage/FUND_QUOTA_ERROR',
};

const initialState = {
  data: {},
};

export const fundQuota = (params = {}) => ({
  type: types.FUND_QUOTA, payload: params,
});
export const fundQuotaSuccess = (params = {}) => ({
  type: types.FUND_QUOTA_SUCCESS, payload: params,
});
export const fundQuotaError = (params = {}) => ({
  type: types.FUND_QUOTA_ERROR, payload: params,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FUND_QUOTA: {
      return {
        ...state,
        loading: true,
      };
    }
    case types.FUND_QUOTA_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    }
    case types.FUND_QUOTA_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
}
